import { StyledFlexColumn } from 'components/StyledUtils/flex';
import {
  StyledExtraTechniciansCount,
  StyledOccurrencesDetailsBg,
  StyledViewOccurrencesButton,
  StyledActivitiesCount,
  StyledOccurrencesCount,
  StyledOccurrencesCountIcon,
  StyledOccurrencesDetails,
  StyledOccurrencesDetailsContainer,
  StyledDailyPendingActivitiesAndOccurrences,
  StyledDailyPendingContainer,
  StyledGrayStrongText,
  StyledHorizontalLine,
} from 'pages/Geolocalize/styled';
import React, { useMemo, useState } from 'react';
import { StyledFlexWrapper } from 'utils/helpers/css';

import { ReactComponent as UnitMarkerIcon } from '../../../../assets/unit-marker-icon.svg';
import {
  StyledHorizontalStackedAvatars,
  StyledHorizontalStackedInitials,
  StyledSubModalTechnicianPinImages,
} from '../styled';
import { getTechniciansLatestDateTime } from '../TechnicianModalMarker';
import TechnicianModalContent from '../TechnicianModalMarker/TechnicianModalContent';
import { getNameInitials } from 'pages/Geolocalize/utils';
import {
  StyledUnitSmallMarkerSvg,
  StyledUnitLargeMarkerSvg,
  StyledNotificationIcon,
  StyledReturnToMainModalArrow,
  StyledSubModalContainer,
  StyledSubModalHeader,
  StyledSubModalHeaderDescription,
  StyledSubModalHeaderVerticalLine,
  StyledTechnicianList,
  StyledTechnicianListVerticalLine,
  StyledUnitGroupName,
  StyledUnitMarkerModal,
  StyledUnitModalMarker,
  StyledUnitName,
  StyledUnitTechnicians,
  StyledUnitWithTechnicians,
  StyledUnitTechnicianPins,
  StyledViewTechniciansSubModalButton,
} from './styled';

export default function UnitModalMarker({ marker }) {
  const [isTechniciansSubModalActive, setIsTechniciansSubModalActive] = useState(false);
  const isTechniciansPresent = useMemo(() => {
    return marker.technicians?.length >= 1;
  }, [marker.technicians]);
  const isOccurrencesPresent = useMemo(() => {
    return (
      (marker.unit?.occurrences?.length > 0 && marker.unit?.occurrences[0]?.analysed > 0) ||
      marker.unit?.occurrences[0]?.notAnalysed > 0
    );
  }, [marker.unit]);

  const activeModalTitle = useMemo(() => {
    return isTechniciansSubModalActive
      ? marker.technicians?.length === 1
        ? '1 TÉCNICO'
        : `${marker.technicians?.length} TÉCNICOS`
      : 'UNIDADE';
  }, [isTechniciansSubModalActive, marker.technicians]);

  const isSingleTechnicianPin = marker.technicians?.length === 1;
  const isDoubleTechnicianPin = marker.technicians?.length === 2;

  const horizontalStackedAvatars = marker.technicians?.map((technician, i) => {
    if (i < 2 && technician.image) {
      return <StyledHorizontalStackedAvatars key={i} src={technician.image} />;
    } else if (i < 2 && !technician.image) {
      return (
        <StyledHorizontalStackedInitials key={i} isOffline={technician.status === 'offline'}>
          {getNameInitials(technician.name)}
        </StyledHorizontalStackedInitials>
      );
    } else {
      return null;
    }
  });

  const activeUnitModalType = useMemo(() => {
    return isTechniciansSubModalActive ? `technicians` : `unit`;
  }, [isTechniciansSubModalActive]);

  return (
    <StyledUnitModalMarker
      marker={marker}
      modalTitle={activeModalTitle}
      type={activeUnitModalType}
      location={{
        latitude: marker.latitude,
        longitude: marker.longitude,
      }}
      onToggle={() => setIsTechniciansSubModalActive(false)}
      pinComponent={
        <>
          {isOccurrencesPresent && (
            <StyledNotificationIcon
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="10" cy="10" r="10" fill="#EEEEEE" />
              <circle cx="10" cy="10" r="8" fill="#F38A00" />
              <path
                d="M8.22266 5.1636L8.54589 9.58192C8.54589 9.86151 8.7075 10.0013 9.03074 10.0013H10.9701C11.2934 10.0013 11.455 9.86151 11.455 9.58192L11.7782 5.1636C11.7782 5.0111 11.7243 4.89672 11.6166 4.82047C11.5358 4.7188 11.428 4.66797 11.2934 4.66797H8.70751C8.57282 4.66797 8.45161 4.7188 8.34387 4.82047C8.26306 4.89672 8.22266 5.0111 8.22266 5.1636Z"
                fill="white"
              />
              <path
                d="M10.0004 11.7812C10.49 11.7812 10.9022 11.9616 11.2371 12.3223C11.5979 12.6573 11.7782 13.0695 11.7782 13.559C11.7782 14.0486 11.5979 14.4737 11.2371 14.8344C10.9022 15.1693 10.49 15.3368 10.0004 15.3368C9.5109 15.3368 9.08578 15.1693 8.72507 14.8344C8.39013 14.4737 8.22266 14.0486 8.22266 13.559C8.22266 13.0695 8.39013 12.6573 8.72507 12.3223C9.08578 11.9616 9.5109 11.7812 10.0004 11.7812Z"
                fill="white"
              />
            </StyledNotificationIcon>
          )}

          {marker.technicians.length > 0 ? (
            <StyledUnitWithTechnicians isSingleTechnicianPin={isSingleTechnicianPin}>
              <StyledUnitTechnicianPins
                isSingleTechnicianPin={isSingleTechnicianPin}
                isDoubleTechnicianPin={isDoubleTechnicianPin}
              >
                {horizontalStackedAvatars.filter((pinImage, i) => {
                  return i < 3 && pinImage;
                })}
                {horizontalStackedAvatars.length > 2 && (
                  <StyledExtraTechniciansCount>+{horizontalStackedAvatars.length - 2}</StyledExtraTechniciansCount>
                )}
                {isSingleTechnicianPin ? <StyledUnitSmallMarkerSvg /> : <StyledUnitLargeMarkerSvg />}
              </StyledUnitTechnicianPins>
            </StyledUnitWithTechnicians>
          ) : (
            <svg width="40" height="48" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_837_2597" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M40 20V4C40 1.79086 38.2091 0 36 0H20H4C1.79086 0 0 1.79086 0 4V20V36C0 38.2091 1.79086 40 4 40H10.3043C13.1806 42.7903 16.4884 45.4461 20 48C23.5116 45.4461 26.8194 42.7903 29.6957 40H36C38.2091 40 40 38.2091 40 36V20Z"
                />
              </mask>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40 20V4C40 1.79086 38.2091 0 36 0H20H4C1.79086 0 0 1.79086 0 4V20V36C0 38.2091 1.79086 40 4 40H10.3043C13.1806 42.7903 16.4884 45.4461 20 48C23.5116 45.4461 26.8194 42.7903 29.6957 40H36C38.2091 40 40 38.2091 40 36V20Z"
                fill="#5144D3"
              />
              <path
                d="M10.3043 40L11.0006 39.2822L10.7097 39H10.3043V40ZM20 48L19.4118 48.8087L20 49.2365L20.5882 48.8087L20 48ZM29.6957 40V39H29.2903L28.9993 39.2822L29.6957 40ZM39 4V20H41V4H39ZM36 1C37.6569 1 39 2.34315 39 4H41C41 1.23858 38.7614 -1 36 -1V1ZM20 1H36V-1H20V1ZM4 1H20V-1H4V1ZM1 4C1 2.34315 2.34315 1 4 1V-1C1.23858 -1 -1 1.23858 -1 4H1ZM1 20V4H-1V20H1ZM1 36V20H-1V36H1ZM4 39C2.34315 39 1 37.6569 1 36H-1C-1 38.7614 1.23858 41 4 41V39ZM10.3043 39H4V41H10.3043V39ZM9.60805 40.7178C12.5295 43.5519 15.8774 46.2383 19.4118 48.8087L20.5882 47.1913C17.0993 44.6539 13.8317 42.0287 11.0006 39.2822L9.60805 40.7178ZM20.5882 48.8087C24.1226 46.2383 27.4705 43.5519 30.3919 40.7178L28.9993 39.2822C26.1683 42.0287 22.9007 44.6539 19.4118 47.1913L20.5882 48.8087ZM36 39H29.6957V41H36V39ZM39 36C39 37.6569 37.6569 39 36 39V41C38.7614 41 41 38.7614 41 36H39ZM39 20V36H41V20H39Z"
                fill="black"
                fillOpacity="0.4"
                mask="url(#path-1-inside-1_837_2597)"
              />
              <path
                d="M26.625 27H26V12.75C26 12.3438 25.6562 12 25.25 12H14.75C14.3125 12 14 12.3438 14 12.75V27H13.375C13.1562 27 13 27.1875 13 27.375V28H27V27.375C27 27.1875 26.8125 27 26.625 27ZM17 14.375C17 14.1875 17.1562 14 17.375 14H18.625C18.8125 14 19 14.1875 19 14.375V15.625C19 15.8438 18.8125 16 18.625 16H17.375C17.1562 16 17 15.8438 17 15.625V14.375ZM17 17.375C17 17.1875 17.1562 17 17.375 17H18.625C18.8125 17 19 17.1875 19 17.375V18.625C19 18.8438 18.8125 19 18.625 19H17.375C17.1562 19 17 18.8438 17 18.625V17.375ZM18.625 22H17.375C17.1562 22 17 21.8438 17 21.625V20.375C17 20.1875 17.1562 20 17.375 20H18.625C18.8125 20 19 20.1875 19 20.375V21.625C19 21.8438 18.8125 22 18.625 22ZM21 27H19V24.375C19 24.1875 19.1562 24 19.375 24H20.625C20.8125 24 21 24.1875 21 24.375V27ZM23 21.625C23 21.8438 22.8125 22 22.625 22H21.375C21.1562 22 21 21.8438 21 21.625V20.375C21 20.1875 21.1562 20 21.375 20H22.625C22.8125 20 23 20.1875 23 20.375V21.625ZM23 18.625C23 18.8438 22.8125 19 22.625 19H21.375C21.1562 19 21 18.8438 21 18.625V17.375C21 17.1875 21.1562 17 21.375 17H22.625C22.8125 17 23 17.1875 23 17.375V18.625ZM23 15.625C23 15.8438 22.8125 16 22.625 16H21.375C21.1562 16 21 15.8438 21 15.625V14.375C21 14.1875 21.1562 14 21.375 14H22.625C22.8125 14 23 14.1875 23 14.375V15.625Z"
                fill="white"
              />
            </svg>
          )}
        </>
      }
      modalComponent={
        !isTechniciansSubModalActive ? (
          <>
            {isTechniciansPresent && (
              <>
                <StyledUnitTechnicians>
                  {marker.technicians.length === 1 ? ` Está aqui:` : `Estão aqui:`}
                  <StyledSubModalTechnicianPinImages
                    isSingleTechnicianPin={isSingleTechnicianPin}
                    isDoubleTechnicianPin={isDoubleTechnicianPin}
                  >
                    {horizontalStackedAvatars.filter((pinImage, i) => {
                      return i < 3 && pinImage;
                    })}
                    {horizontalStackedAvatars.length > 2 && (
                      <StyledExtraTechniciansCount>+{horizontalStackedAvatars.length - 2}</StyledExtraTechniciansCount>
                    )}
                  </StyledSubModalTechnicianPinImages>
                  <StyledViewTechniciansSubModalButton onClick={() => setIsTechniciansSubModalActive(true)}>
                    Conferir
                  </StyledViewTechniciansSubModalButton>
                </StyledUnitTechnicians>
              </>
            )}
            <StyledUnitMarkerModal>
              <StyledUnitGroupName>{marker.company}</StyledUnitGroupName>
              <StyledUnitName>
                <UnitMarkerIcon /> {marker.unit?.name || '---'}
              </StyledUnitName>
              {isOccurrencesPresent ? (
                <StyledDailyPendingContainer>
                  <StyledHorizontalLine />
                  <StyledDailyPendingActivitiesAndOccurrences hasMarginTop>
                    Pendente nessa unidade hoje:
                  </StyledDailyPendingActivitiesAndOccurrences>
                  <StyledOccurrencesDetailsContainer>
                    <StyledFlexColumn>
                      <StyledOccurrencesCount>
                        <StyledFlexWrapper alignItems="center">
                          <StyledOccurrencesCountIcon
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="8" cy="8" r="8" fill="#F38A00" />
                            <path
                              d="M6.22266 3.16262L6.54589 7.58095C6.54589 7.86053 6.7075 8.00033 7.03074 8.00033H8.97013C9.29336 8.00033 9.45498 7.86053 9.45498 7.58095L9.77821 3.16262C9.77821 3.01012 9.72434 2.89575 9.6166 2.81949C9.53579 2.71783 9.42804 2.66699 9.29336 2.66699H6.70751C6.57282 2.66699 6.45161 2.71783 6.34387 2.81949C6.26306 2.89575 6.22266 3.01012 6.22266 3.16262Z"
                              fill="white"
                            />
                            <path
                              d="M8.00043 9.77832C8.48997 9.77832 8.9022 9.95867 9.23715 10.3194C9.59786 10.6543 9.77821 11.0666 9.77821 11.5561C9.77821 12.0456 9.59786 12.4708 9.23715 12.8315C8.9022 13.1664 8.48997 13.3339 8.00043 13.3339C7.5109 13.3339 7.08578 13.1664 6.72507 12.8315C6.39013 12.4708 6.22266 12.0456 6.22266 11.5561C6.22266 11.0666 6.39013 10.6543 6.72507 10.3194C7.08578 9.95867 7.5109 9.77832 8.00043 9.77832Z"
                              fill="white"
                            />
                          </StyledOccurrencesCountIcon>
                          <b>{marker.unit?.occurrences[0].analysed + marker.unit?.occurrences[0].notAnalysed}</b>
                        </StyledFlexWrapper>
                        <StyledGrayStrongText>Ocorrências</StyledGrayStrongText>
                      </StyledOccurrencesCount>
                      <StyledActivitiesCount>
                        <b>{marker.unit?.activitiesCount}</b>
                        <StyledGrayStrongText>Atividades</StyledGrayStrongText>
                      </StyledActivitiesCount>
                    </StyledFlexColumn>
                    <StyledOccurrencesDetails>
                      <StyledFlexColumn>
                        <StyledGrayStrongText>{marker.unit?.occurrences[0].analysed} analisada(s)</StyledGrayStrongText>
                        <StyledGrayStrongText>
                          {marker.unit?.occurrences[0].notAnalysed} não analisada(s)
                        </StyledGrayStrongText>
                      </StyledFlexColumn>
                      <StyledViewOccurrencesButton
                        href="https://app.leankeep.com/Anomalias/ShowAnomaliasTablePage.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver ocorrências
                      </StyledViewOccurrencesButton>

                      <StyledOccurrencesDetailsBg
                        width="160"
                        height="96"
                        viewBox="0 0 160 96"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask id="path-1-inside-1_1501_70" fill="white">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M160 4C160 1.79086 158.209 0 156 0H12C9.79085 0 7.99999 1.79086 7.99999 4V11.5858V11.7975C7.46539 12.3558 5.80074 14.132 4.19735 15.8459C3.29099 16.8148 2.40027 17.7681 1.73616 18.4791L0.936278 19.3356L0.713224 19.5745L0.654571 19.6373L0.639544 19.6534L0.635741 19.6575L0.634783 19.6585L0.634543 19.6588C0.634489 19.6589 0.634462 19.6589 0.999991 20L0.634462 19.6589L0.315338 20.0008L0.635223 20.342L7.99999 28.1977V28.4142V92C7.99999 94.2091 9.79085 96 12 96H156C158.209 96 160 94.2091 160 92V4Z"
                          />
                        </mask>
                        <path
                          d="M7.99999 11.7975L8.72226 12.4891L8.99999 12.1991V11.7975H7.99999ZM4.19735 15.8459L4.92763 16.5291L4.92763 16.5291L4.19735 15.8459ZM1.73616 18.4791L1.00537 17.7965L1.00529 17.7965L1.73616 18.4791ZM0.936278 19.3356L0.205414 18.6531L0.205307 18.6532L0.936278 19.3356ZM0.713224 19.5745L-0.0177461 18.8921L-0.0177916 18.8922L0.713224 19.5745ZM0.654571 19.6373L-0.076445 18.955L-0.0764749 18.955L0.654571 19.6373ZM0.639544 19.6534L1.37052 20.3359L1.37059 20.3358L0.639544 19.6534ZM0.635741 19.6575L-0.0952331 18.9751L-0.0954898 18.9754L0.635741 19.6575ZM0.634783 19.6585L1.36571 20.341L1.36601 20.3407L0.634783 19.6585ZM0.634543 19.6588L1.3637 20.3432L1.36547 20.3413L0.634543 19.6588ZM0.634462 19.6589L1.31678 18.9278L0.58572 18.2455L-0.0965936 18.9766L0.634462 19.6589ZM0.315338 20.0008L-0.415718 19.3185L-1.05397 20.0023L-0.414198 20.6848L0.315338 20.0008ZM0.635223 20.342L-0.0943124 21.026L-0.0943117 21.026L0.635223 20.342ZM7.99999 28.1977H8.99999V27.8023L8.72953 27.5138L7.99999 28.1977ZM156 1C157.657 1 159 2.34315 159 4H161C161 1.23857 158.761 -1 156 -1V1ZM12 1H156V-1H12V1ZM8.99999 4C8.99999 2.34315 10.3431 1 12 1V-1C9.23857 -1 6.99999 1.23858 6.99999 4H8.99999ZM8.99999 11.5858V4H6.99999V11.5858H8.99999ZM8.99999 11.7975V11.5858H6.99999V11.7975H8.99999ZM4.92763 16.5291C6.53346 14.8125 8.19281 13.042 8.72226 12.4891L7.27772 11.1059C6.73798 11.6696 5.06802 13.4514 3.46708 15.1628L4.92763 16.5291ZM2.46695 19.1617C3.13096 18.4508 4.02149 17.4977 4.92763 16.5291L3.46708 15.1628C2.56048 16.1319 1.66958 17.0853 1.00537 17.7965L2.46695 19.1617ZM1.66714 20.0181L2.46702 19.1616L1.00529 17.7965L0.205414 18.6531L1.66714 20.0181ZM1.44419 20.2569L1.66725 20.018L0.205307 18.6532L-0.0177461 18.8921L1.44419 20.2569ZM1.38559 20.3197L1.44424 20.2569L-0.0177916 18.8922L-0.076445 18.955L1.38559 20.3197ZM1.37059 20.3358L1.38562 20.3197L-0.0764749 18.955L-0.0915019 18.9711L1.37059 20.3358ZM1.36671 20.3399L1.37052 20.3359L-0.0914297 18.971L-0.0952331 18.9751L1.36671 20.3399ZM1.36601 20.3407L1.36697 20.3397L-0.0954898 18.9754L-0.0964471 18.9764L1.36601 20.3407ZM1.36547 20.3413L1.36571 20.341L-0.0961453 18.9761L-0.0963857 18.9764L1.36547 20.3413ZM1.6823 19.269C1.49951 19.0984 1.40826 19.0132 1.36272 18.9707C1.33977 18.9492 1.32895 18.9391 1.32392 18.9344C1.32068 18.9314 1.32177 18.9324 1.32398 18.9345C1.32474 18.9352 1.32656 18.9369 1.32893 18.9392C1.33044 18.9407 1.33646 18.9465 1.34404 18.9541C1.34777 18.9579 1.35552 18.9657 1.36506 18.9759C1.37148 18.9828 1.39461 19.0075 1.42135 19.0416C1.4348 19.0588 1.46056 19.0926 1.48844 19.1384C1.512 19.177 1.56723 19.2722 1.60228 19.4068C1.64312 19.5637 1.65942 19.7886 1.56331 20.0295C1.52031 20.1372 1.46658 20.2173 1.4268 20.269C1.41174 20.2881 1.38825 20.316 1.38018 20.3252C1.37201 20.3342 1.36371 20.3431 1.3637 20.3432L-0.0946152 18.9745C-0.0946248 18.9745 -0.10292 18.9834 -0.111097 18.9925C-0.119169 19.0016 -0.142653 19.0295 -0.157718 19.0486C-0.1975 19.1003 -0.251222 19.1804 -0.294231 19.2882C-0.390339 19.529 -0.37404 19.7539 -0.333193 19.9108C-0.298145 20.0454 -0.242917 20.1406 -0.219349 20.1793C-0.191472 20.225 -0.16571 20.2589 -0.152254 20.276C-0.125501 20.3101 -0.102354 20.3349 -0.095913 20.3418C-0.0863471 20.352 -0.0785692 20.3599 -0.0747933 20.3637C-0.0671266 20.3714 -0.060975 20.3773 -0.059268 20.379C-0.0567043 20.3815 -0.0546146 20.3834 -0.0535066 20.3845C-0.0498769 20.3879 -0.0459419 20.3916 -0.0434842 20.3939C-0.0371057 20.3999 -0.0251056 20.4111 -0.00237436 20.4324C0.0434435 20.4751 0.134944 20.5606 0.317677 20.7311L1.6823 19.269ZM-0.0478517 20.39L0.317677 20.7311L1.6823 19.269L1.31678 18.9278L-0.0478517 20.39ZM1.04639 20.6831L1.36552 20.3412L-0.0965936 18.9766L-0.415718 19.3185L1.04639 20.6831ZM1.36476 19.6581L1.04487 19.3169L-0.414198 20.6848L-0.0943124 21.026L1.36476 19.6581ZM8.72953 27.5138L1.36476 19.6581L-0.0943117 21.026L7.27046 28.8817L8.72953 27.5138ZM8.99999 28.4142V28.1977H6.99999V28.4142H8.99999ZM8.99999 92V28.4142H6.99999V92H8.99999ZM12 95C10.3431 95 8.99999 93.6569 8.99999 92H6.99999C6.99999 94.7614 9.23857 97 12 97V95ZM156 95H12V97H156V95ZM159 92C159 93.6569 157.657 95 156 95V97C158.761 97 161 94.7614 161 92H159ZM159 4V92H161V4H159Z"
                          fill="#F38A00"
                          mask="url(#path-1-inside-1_1501_70)"
                        />
                      </StyledOccurrencesDetailsBg>
                    </StyledOccurrencesDetails>
                  </StyledOccurrencesDetailsContainer>
                </StyledDailyPendingContainer>
              ) : marker.unit?.activitiesCount > 0 ? (
                <>
                  <StyledFlexWrapper flexDirection="column" alignItems="center">
                    <StyledHorizontalLine />
                    <StyledDailyPendingActivitiesAndOccurrences>
                      Pendente nessa unidade hoje:
                    </StyledDailyPendingActivitiesAndOccurrences>
                    <StyledActivitiesCount>
                      <b>{marker.unit?.activitiesCount}</b>
                      <StyledGrayStrongText>Atividades</StyledGrayStrongText>
                    </StyledActivitiesCount>
                  </StyledFlexWrapper>
                </>
              ) : (
                <></>
              )}
            </StyledUnitMarkerModal>
          </>
        ) : (
          <StyledSubModalContainer>
            <StyledSubModalHeader>
              <StyledReturnToMainModalArrow onClick={() => setIsTechniciansSubModalActive(false)}>
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 1L1 6L6 11"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </StyledReturnToMainModalArrow>
              <StyledSubModalHeaderVerticalLine />
              <StyledFlexColumn>
                <StyledSubModalHeaderDescription>
                  {marker.technicians.length === 1 ? `Está` : 'Estão'} na unidade:
                </StyledSubModalHeaderDescription>
                <StyledFlexWrapper>
                  <UnitMarkerIcon style={{ transform: 'translateY(5px)', marginRight: '8px' }} />
                  <StyledUnitName>{marker.unit?.name}</StyledUnitName>
                </StyledFlexWrapper>
              </StyledFlexColumn>
            </StyledSubModalHeader>
            <StyledTechnicianList>
              <TechnicianModalContent
                marker={marker}
                latestLocalization={getTechniciansLatestDateTime(marker.technicians).time}
              />
            </StyledTechnicianList>
            {marker.technicians.length > 2 && <StyledTechnicianListVerticalLine />}
          </StyledSubModalContainer>
        )
      }
    />
  );
}
